import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';



@Injectable()
export class UserBankService {
    constructor(
        private httpService: HttpService) { }

    //获取用户银行信息
    //TQQ 2017-01-03
    getUserBanks(pageIndex: number, pageSize: number) {
        let param = "pageIndex=" + pageIndex + "&pageSize=" + pageSize;
        let url = AppConfig.GetProdUrl() + "/User/GetUserBanks";
        return this.httpService.get(url + "?" + param);
    }

    //设为默认银行
    //TQQ 2017-01-03
    setDefaultBank(bankid) {
        let param = "id=" + bankid;
        let url = AppConfig.GetProdUrl() + "/User/SetDefaultCard";
        return this.httpService.get(url + "?" + param);
    }


    //验证用户是否绑定银行卡
    //chen 2017-01-03
    getUserBank() {
        let url = AppConfig.GetProdUrl() + "/User/ExistUserBank" ;
        return this.httpService.get(url);
    }

    //查询可提现的银行列表
    queryDrawBanks() {
        // let url = AppConfig.GetProdUrl() + "/User/QueryDrawBanks";
        let url = AppConfig.GetProdUrl() + "/User/GetWalletList";
        return this.httpService.get(url, { walletType: '' });
    }

    //省列表
    //TQQ 2017-01-03
    proList() {
        let url = AppConfig.GetProdUrl() + "/User/ProList";
        return this.httpService.get(url);
    }

    //市列表
    //TQQ 2017-01-03
    cityList(procode: string) {
        let url = AppConfig.GetProdUrl() + "/User/CityList?proCode=" + procode;
        return this.httpService.get(url);
    }

    //区列表
    //TQQ 2017-01-03
    areaList(cityCode: string) {
        let url = AppConfig.GetProdUrl() + "/User/AreaList?cityCode=" + cityCode;
        return this.httpService.get(url);
    }

    //添加银行卡 
    //TQQ 2017-01-03
    addUserBank(bank){
        let url = AppConfig.GetProdUrl() + "/User/AddUserBank";
        return this.httpService.post(url,bank);
    }
}




// WEBPACK FOOTER //
// ./src/services/userbank.service.ts